import f from "../funcs";
import $ from "jquery";


// TODO: удаляя пробел, удалять цифру слево от пробела

$.fn.onlyNumber = function(params) {
    params = f.deepMixin({
        min: -1 / 0,
        max: 1 / 0,
        round: 1000
    }, params);

    return this.each(function() {
        let $input = $(this);
        // фиксим утечки памяти
        let eventKey = params.eventKey
            ? params.eventKey + " "
            : " ";

        let value = $input.val() || "";
        value = value.replace(/\s/g, "");
        value = addSpacesByParams(value, params.withoutSpaces);
        $input.val(value);

        // char на другом событии не узнать,
        // при этом сохранив возможность отменить вставку символа в инпут
        $input.on("keypress" + eventKey, $.fn.onlyNumber.onKeypress.bind(0, params));

        // обрабатываем пробелы, после delete/backspace и min, max
        $input.on("keyup" + eventKey, $.fn.onlyNumber.onKeyup.bind(0, params));

        // мышкой можно вставить в инпут любой текст
        $input.on("blur" + eventKey, $.fn.onlyNumber.onBlur.bind(0, params));
    });
};

$.fn.onlyNumber.onKeypress = function(params, e) {
    let char = getChar(e);

    if ( !char ) { // Если ввели не символ, продолжать бессмысленно
        return;
    }
    let input = e.target;


    let $input = $(input);
    e.preventDefault();

    let value = input.value || "";
    let offset = input.selectionStart;
    let newValue = value;

    // удобство уровень максимум
    if ( char == "," ) {
        char = ".";
    }

    // второй минус нам ненужен и он только в начале
    if ( char == "-" && (offset !== 0 || newValue.indexOf("-") != -1) ) {
        return;
    }

    // буква и другая дичь
    if ( !/[\d.-]/.test(char) ) {
        return;
    }

    // вторая точка нам ненужна
    if ( char == "." && newValue.indexOf(".") != -1 ) {
        // ожидаем
        // 1.234_567 => 1 234.567
        // получается
        // 1.234_567 => 12 345.67
        // чтобы пофиксить заменяю прошлую точку на пробел (раньше просто удалял)
        newValue = newValue.replace(".", " ");
    }

    // округление до целых, не даем вставить точку
    if ( params.round === 0 && char == "." ) {
        return;
    }

    newValue = newValue.slice(0, offset) + char + newValue.slice(input.selectionEnd);
    offset++;

    let withoutSpaces = newValue.replace(/ /g, "");
    if ( params.min !== false && +withoutSpaces < +params.min && withoutSpaces !== "" ) {
        newValue = params.min + "";
    }

    if ( params.max !== false && +withoutSpaces > +params.max && withoutSpaces !== "" ) {
        newValue = params.max + "";
    }

    if (
        params.round > 0
            && newValue.indexOf(".") != -1
            && newValue.split(".")[1].length > params.round
    ) {
        newValue = newValue.slice(0, offset) + newValue.slice(offset + 1);
        newValue = newValue.split(".")[0] + "." + newValue.split(".")[1].slice(0, params.round);
    }

    let withSpaces = addSpacesByParams(newValue, params.withoutSpaces);
    if ( withSpaces != newValue ) {
        offset = getOffsetAfterAddSpaces(newValue, withSpaces, offset);
        newValue = withSpaces;
    }

    if ( newValue != value ) {
        input.value = newValue;
        input.setSelectionRange(offset, offset);
        $input.trigger("change", e);
    }
};

$.fn.onlyNumber.onKeyup = function(params, e) {
    let input = e.target;
    let offset = input.selectionStart;

    // когда предвигаемся кнопками влево и вправо,
    // то надо перепрыгивать пробелы

    if ( input.value ) {
        // left arrow
        if ( e.keyCode == 37 ) {
            let leftChar = input.value[ offset - 1 ];
            let currentChar = input.value[ offset ];

            if ( leftChar == " " || currentChar == " " ) {
                offset--;
                input.setSelectionRange(offset, offset);
            }
            return;
        }

        // right arrow
        if ( e.keyCode == 39 ) {
            let rightChar = input.value[ offset ]; // +1 НЕ нужен
            let currentChar = input.value[ offset - 1 ];

            if ( rightChar == " " || currentChar == " " ) {
                offset++;
                input.setSelectionRange(offset, offset);
            }
            return;
        }
    }


    // delete 46
    // backspace 8
    // ctrl+v
    if ( e.keyCode != 46 && e.keyCode != 8 && e.keyCode != 86 ) {
        return;
    }


    let $input = $(input);

    let value = input.value || "";
    if ( value === "" ) {
        $input.trigger("change", e);
        return;
    }

    // сумма операции 45000
    // ситарю 45
    // остается не 000, а 0
    if ( /(000 | 000)+(\.\d*)?/.test(value) ) {
        return;
    }

    let zeroTail = /\.0+$/.test(value) ? "." + value.split(".").pop() : "";
    let newValue = value;

    if ( newValue ) {
        // ctr+v 123,45 => 123
        // fix:
        newValue = (newValue + "").replace(/,/g, ".");
        newValue = newValue.replace(/[^\-.\d ]/g, "");
    }

    if ( params.min !== false && +newValue < +params.min && newValue !== "" ) {
        newValue = params.min + "";
    }
    newValue += zeroTail;

    let tail = newValue.split(".").pop();
    if ( params.round > 0 && tail.length > params.round ) {
        newValue = f.round2(+f.currencyToNumber(newValue), params.round) + "";
    }

    // максимальное может быть отрицательным
    // например:
    // max -10 000,
    // input.value -1X0 000
    // и пользователь жмет удаление символа
    if ( params.max !== false && +f.currencyToNumber(newValue) > +params.max && newValue !== "" ) {
        newValue = params.max + "";
    }

    let withSpaces = addSpacesByParams(newValue, params.withoutSpaces);
    if ( withSpaces != newValue ) {
        offset = getOffsetAfterAddSpaces(newValue, withSpaces, offset);
        newValue = withSpaces;
    }

    if ( newValue != value ) {
        input.value = newValue;
        input.setSelectionRange(offset, offset);
    }

    $input.trigger("change", e);
};

$.fn.onlyNumber.onBlur = function(params, e) {
    let input = e.target;


    let $input = $(input);

    let value = input.value || "";
    if ( value === "" ) {
        return;
    }

    let newValue = value;
    newValue = newValue.replace(/[^\d.,-]/g, "");
    newValue = newValue.replace(/,/g, ".");
    newValue = newValue.replace(/(.)-/g, "$1");

    if ( params.round > 0 ) {
        newValue = f.round2(+newValue, params.round) + "";
    }

    if ( params.min !== false && +newValue < +params.min && newValue !== "" ) {
        newValue = params.min + "";
    }

    if ( params.max !== false && +newValue > +params.max && newValue !== "" ) {
        newValue = params.max + "";
    }

    newValue = addSpacesByParams(newValue, params.withoutSpaces);

    if ( newValue != value ) {
        input.value = newValue;
        $input.trigger("change", e);
    }
};

// была строка
// "1X 234"
// обработали пробелы стала =>
// "17X 234"
// где X это положение курсора клавы
//
// считаем кол-во пробелов перед кареткой, которое было и стало
// разница, это то сколько нужно добавить к каретке,
// как-будто пользователь ввел 2 символа
function getOffsetAfterAddSpaces(oldValue, newValue, offset) {
    let oldCount;
    oldCount = oldValue.slice(0, offset).match(/\s/g);
    if ( oldCount ) {
        oldCount = oldCount.length;
    } else {
        oldCount = 0;
    }

    let newCount;
    newCount = newValue.slice(0, offset).match(/\s/g);
    if ( newCount ) {
        newCount = newCount.length;
    } else {
        newCount = 0;
    }

    offset += newCount - oldCount;

    return offset;
}

// https://learn.javascript.ru/keyboard-events
function getChar(event) {

    //сочетания системных клавиш, кроме сочетаний с shift не являются валидными символами
    if ( event.ctrlKey || event.altKey ) {
        return null;
    }

    if ( event.which == null ) {
        if ( event.keyCode < 32 ) return null;
        return String.fromCharCode(event.keyCode); // IE
    }

    if ( event.which !== 0 && event.charCode !== 0 ) {
        if ( event.which < 32 ) return null;
        return String.fromCharCode(event.which); // остальные
    }

    return null; // специальная клавиша
}

function addSpacesByParams(value, withoutSpaces = false) {
    const newValue = withoutSpaces ? value : f.addSpaces(value);

    return newValue;
}

export default $.fn.onlyNumber;
